import script from "./HeaderEditing.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderEditing.vue?vue&type=script&setup=true&lang=js"

import "./HeaderEditing.vue?vue&type=style&index=0&id=0dd74260&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd74260"]])

export default __exports__